<!-- Search bar with clear button -->
<div class="px-5 pt-2">
  <div class="relative">
    <!-- Search input -->
    <input
      class="h-10 w-full rounded-md border border-neutral-300 bg-white pr-10 pl-10 text-sm focus:border-neutral-800 focus:outline-none"
      [placeholder]="placeholder()"
      [ngModel]="searchTerm"
      (ngModelChange)="onSearchChange()"
      type="text"
    />
    <div class="absolute top-1/2 left-3 -translate-y-1/2 transform">
      <svg
        class="h-4 w-4 text-neutral-400"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Clear button -->
    <button
      class="group absolute top-1/2 right-3 -translate-y-1/2 transform rounded-full p-1 transition-colors duration-200 hover:bg-neutral-100"
      (click)="clearSearch()"
      (keydown.enter)="clearSearch()"
      (keydown.space)="clearSearch(); $event.preventDefault()"
      aria-label="Clear search"
    >
      <svg
        class="h-4 w-4 text-neutral-500 transition-colors duration-200 group-hover:text-neutral-700"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</div>
